module.exports = __webpack_public_path__ + "images/refer-icon.png";


//////////////////
// WEBPACK FOOTER
// ./images/refer-icon.png
// module id = 1129
// module chunks = 1